import styled from "styled-components";

const Modal = styled.div`
  position: fixed;
  top: 25px;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  opacity: 0;
  width: 430px;
  max-width: calc((100vw - 40px));
  height: 700px;
  max-height: calc((100vh - 70px));
  box-sizing: border-box;
  margin-right: auto;
  margin-left: auto;
  z-index: 3;
  &.fade-in {
    opacity: 1;
    -webkit-transition: 0.01s;
    -moz-transition: 0.01s;
    -o-transition: 0.01s;
    transition: 0.01s;
  }
  &.fade-out {
    opacity: 0;
    -webkit-transition: 0.01s;
    -moz-transition: 0.01s;
    -o-transition: 0.01s;
    transition: 0.01s;
  }
  .background {
    background: #19214f78;
    position: fixed;
    z-index: 1040;
    display: block;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    outline: 0;
  }
  .box-header {
    text-align: right;
  }
  .box-dialog {
    border-radius: 7px;
    z-index: 1050;
    width: 100%;
    background-color: ${(props) => {
      if (props.backgroundColor) {
        return props.backgroundColor;
      } else {
        return "#fff";
      }
    }};
    box-shadow: 0px 0px 3px 3px rgba(0, 0, 0, 0.071);
    .box-body {
      font-size: 14px;
      padding-left: 0px;
      padding-right: 0px;
      padding-top: 0px;
      padding-bottom: 0px;
      overflow-y: auto;
      overflow-x: hidden;
      max-height: calc((100vh - 150px));
      box-sizing: border-box;
    }
    .x-close {
      font-size: 35px;
      line-height: 35px;
      font-weight: 400;
      text-shadow: none;
      color: black;
      cursor: pointer;
      &:hover {
        opacity: 0.5;
      }
    }
  }
`;

export default Modal;
